import client from '@/http'
import dayjs from "dayjs";

const loadAll = (context) => {
  client.get(
    '/items'
  ).then(
    (res) => {
      context.commit('SET_ITEMS', res.data)
    }
  ).catch(
    (err) => {
      console.error(err)
    }
  )
}

const load = (context, itemId) => {
  client.get(
    `/items/${itemId}`
  ).then(
    (res) => {
      context.commit('SET_ITEM', res.data)
    }
  ).catch(
    (err) => {
      console.error(err)
    }
  )
}

const save = (context, params) => {
  if (params.id) {
    client.put(
      `/items/${params.id}`, params
    ).then(
      () => {
        context.commit('UPDATE', params)
      }
    ).catch(
      (err) => {
        console.error(err)
      }
    )
  } else {
    client.post(
      '/items', params
    ).then(
      (res) => {
        context.commit('PUSH', res.data)
      }
    ).catch(
      (err) => {
        console.error(err)
      }
    )
  }

  context.commit('RESET')
}

const remove = (context, itemId) => {
  client.delete(
    `/items/${itemId}`
  ).then(
    () => {
      context.commit('REMOVE', itemId)
    }
  ).catch(
    (err) => {
      console.error(err)
    }
  )
}

const grant = (context, params) => {
  client.post(
    '/users/allow', params
  ).then(
    () => {
      context.commit('PUSH_GRANT', {
        itemId: params.itemId,
        user: context.rootGetters['users/users'].find(x => x.id === params.userId)
      })
    }
  ).catch(
    (err) => {
      console.error(err)
    }
  )
}

const revoke = (context, params) => {
  client.post(
    '/users/deny', params
  ).then(
    () => {
      context.commit('REVOKE_GRANT', params)
    }
  ).catch(
    (err) => {
      console.error(err)
    }
  )
}

const include = (context, params) => {
  client.post(
    '/bundles/allow', {
      itemId: params.itemId,
      bundleId: params.bundleId
    }
  ).then(
    () => {
      context.commit('INCLUDE_BUNDLE', {
        itemId: params.itemId,
        bundle: context.rootGetters['bundles/bundles'].find(x => x.id === params.bundleId)
      })
    }
  ).catch(
    (err) => {
      console.error(err)
    }
  )
}

const exclude = (context, params) => {
  client.post(
    '/bundles/deny', params
  ).then(
    () => {
      context.commit('EXCLUDE_BUNDLE', params)
    }
  ).catch(
    (err) => {
      console.error(err)
    }
  )
}

const download = (context) => {
  client.get('items/export', {
    responseType: 'blob'
  }).then(
    res => {
      context.commit('SET_BUILDING', false)

      const timestamp = dayjs().format('DD-MM-YYYY_HH-mm-ss')
      const filename = `accounts_${timestamp}.xlsx`
      const blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = filename
      link.click()
    }
  )
}

export default {
  save,
  remove,
  load,
  loadAll,
  grant,
  revoke,
  include,
  exclude,
  download
}
